import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getFirstBranch } from '@/utils/auth';
export default {
  name: 'InstSuggest',
  props: {
    value: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return '请输入关键词';
      }
    },
    maxLength: {
      type: Number,
      default: 500
    },
    size: {
      type: String,
      default: 'small'
    },
    height: {
      type: String,
      default: function _default() {
        return '28px';
      }
    },
    // 联想类型
    suggestType: {
      type: String,
      default: function _default() {
        return 'title';
      }
    },
    // 用于同时需要限制多个部门的orgid
    multipleOrgId: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 用于只需要限制一个部门的orgid
    singleOrgId: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    url: {
      type: String,
      default: function _default() {
        return '/ie/manage/common/selectInstByTitleOrIssueNum';
      }
    },
    params: {
      type: Object,
      default: function _default() {
        return {
          title: '',
          issueNum: ''
        };
      }
    }
  },
  data: function data() {
    return {
      suggestValue: '',
      firstBranch: ''
    };
  },
  watch: {
    value: {
      handler: function handler(n) {
        if (n !== this.suggestValue) {
          this.suggestValue = n;
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     *  @description 联想输入框搜索
     *  @param { String } keyWord
     *  @param { cb } cb
     *  @author runtang.zeng✨
     * */
    querySearch: function querySearch(keyWord, cb) {
      var data = _objectSpread({}, this.params);
      data.searchKey = keyWord;
      if (this.singleOrgId) {
        data.publishOrgIds = [this.singleOrgId];
      } else {
        data.publishOrgIds = _toConsumableArray(this.multipleOrgId);
        if (getFirstBranch()) {
          data.publishOrgIds = [getFirstBranch()].concat(_toConsumableArray(this.multipleOrgId));
        }
      }
      this.$API.postRequest({
        url: this.url,
        data: data
      }).then(function (res) {
        if (res.code === '0000000000') {
          cb(res.result.records || res.result || []);
        } else {
          cb([]);
        }
      });
    },
    handleInput: function handleInput(val) {
      this.$emit('input', val);
      this.$forceUpdate();
    },
    handleSelect: function handleSelect(item) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('select', item);
                _context.next = 3;
                return _this.$nextTick();
              case 3:
                _this.$emit('input', item[_this.suggestType]);
                _this.$forceUpdate();
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleClear: function handleClear() {
      this.$emit('clear');
      document.activeElement.blur();
    },
    handleBlur: function handleBlur(event) {
      this.$emit('blur', event);
    }
  }
};